import { c as _c } from "react/compiler-runtime";
import { StoreImageEnum } from '@systemeio/digital-store-shared';
import { FormInput, Hint } from '@systemeio/ui';
import StoreFields from 'modules/stores/store/components/contact-fields';
import ItemSteps from 'modules/stores/store/components/item-steps';
import StoreImageSelector from 'modules/stores/store/components/store-image-selector';
import { StoreTextEditor } from 'modules/stores/store/components/store-text-editor';
import { PhysicalProductItemEditType, PhysicalProductItemErrorsType } from 'modules/stores/store/content/product/types/product-interface';
import { Dispatch, SetStateAction } from 'react';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import PaymentMethodsEditModal from '../../components/payment-methods-edit-modal';
import { twJoin } from 'tailwind-merge';
import { physicalProductInitFields } from '../constants/mandatory-fields';
import { advancedTextEditorExtensions } from '@systemeio/tip-tap';
interface PhysicalCheckoutProps {
  tempState: PhysicalProductItemEditType;
  setTempState: Dispatch<SetStateAction<PhysicalProductItemEditType>>;
  errors: PhysicalProductItemErrorsType;
  imageType: StoreImageEnum;
}
export const PhysicalCheckout = t0 => {
  const $ = _c(85);
  const {
    tempState,
    setTempState,
    errors,
    imageType
  } = t0;
  const {
    t
  } = useLocoTranslation();
  let t1;
  if ($[0] !== t) {
    t1 = t("dashboard.store.image.select_image");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = tempState.checkoutPage.cover;
  let t3;
  if ($[2] !== t) {
    t3 = t("dashboard.store.product.checkout_image_label");
    $[2] = t;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== setTempState) {
    t4 = dataFile => setTempState(prev => ({
      ...prev,
      checkoutPage: {
        ...prev.checkoutPage,
        cover: dataFile
      }
    }));
    $[4] = setTempState;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== imageType || $[7] !== t3 || $[8] !== t4 || $[9] !== tempState.checkoutPage.cover) {
    t5 = <StoreImageSelector dataFile={t2} imageType={imageType} label={t3} onChange={t4} />;
    $[6] = imageType;
    $[7] = t3;
    $[8] = t4;
    $[9] = tempState.checkoutPage.cover;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t1 || $[12] !== t5) {
    t6 = {
      key: "image",
      title: t1,
      element: t5
    };
    $[11] = t1;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t) {
    t7 = t("dashboard.store.item.add_text");
    $[14] = t;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  const t8 = tempState.checkoutPage.title;
  let t9;
  if ($[16] !== t) {
    t9 = t("dashboard.store.item.title");
    $[16] = t;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== setTempState) {
    t10 = t11 => {
      const {
        target: t12
      } = t11;
      const {
        value
      } = t12;
      return setTempState(prev_0 => ({
        ...prev_0,
        checkoutPage: {
          ...prev_0.checkoutPage,
          title: value
        }
      }));
    };
    $[18] = setTempState;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  const t11 = errors["checkoutPage.title"];
  let t12;
  if ($[20] !== t10 || $[21] !== t11 || $[22] !== t9 || $[23] !== tempState.checkoutPage.title) {
    t12 = <FormInput required={true} value={t8} label={t9} onChange={t10} error={t11} />;
    $[20] = t10;
    $[21] = t11;
    $[22] = t9;
    $[23] = tempState.checkoutPage.title;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  const t13 = tempState.checkoutPage.buttonTitle;
  let t14;
  if ($[25] !== t) {
    t14 = t("dashboard.store.item.button");
    $[25] = t;
    $[26] = t14;
  } else {
    t14 = $[26];
  }
  let t15;
  if ($[27] !== setTempState) {
    t15 = t16 => {
      const {
        target: t17
      } = t16;
      const {
        value: value_0
      } = t17;
      return setTempState(prev_1 => ({
        ...prev_1,
        checkoutPage: {
          ...prev_1.checkoutPage,
          buttonTitle: value_0
        }
      }));
    };
    $[27] = setTempState;
    $[28] = t15;
  } else {
    t15 = $[28];
  }
  const t16 = errors["checkoutPage.buttonTitle"];
  let t17;
  if ($[29] !== t14 || $[30] !== t15 || $[31] !== t16 || $[32] !== tempState.checkoutPage.buttonTitle) {
    t17 = <FormInput required={true} value={t13} label={t14} onChange={t15} error={t16} />;
    $[29] = t14;
    $[30] = t15;
    $[31] = t16;
    $[32] = tempState.checkoutPage.buttonTitle;
    $[33] = t17;
  } else {
    t17 = $[33];
  }
  let t18;
  if ($[34] !== t12 || $[35] !== t17) {
    t18 = <div className="grid grid-cols-1 gap-5 sm:grid-cols-2">{t12}{t17}</div>;
    $[34] = t12;
    $[35] = t17;
    $[36] = t18;
  } else {
    t18 = $[36];
  }
  let t19;
  if ($[37] !== t) {
    t19 = t("dashboard.store.item.description");
    $[37] = t;
    $[38] = t19;
  } else {
    t19 = $[38];
  }
  const t20 = tempState.checkoutPage.description;
  let t21;
  if ($[39] !== setTempState) {
    t21 = value_1 => setTempState(prev_2 => ({
      ...prev_2,
      checkoutPage: {
        ...prev_2.checkoutPage,
        description: value_1
      }
    }));
    $[39] = setTempState;
    $[40] = t21;
  } else {
    t21 = $[40];
  }
  const t22 = errors["checkoutPage.description"] && "border-danger";
  let t23;
  if ($[41] !== t22) {
    t23 = twJoin(t22);
    $[41] = t22;
    $[42] = t23;
  } else {
    t23 = $[42];
  }
  const t24 = errors["checkoutPage.description"];
  let t25;
  if ($[43] !== t19 || $[44] !== t21 || $[45] !== t23 || $[46] !== t24 || $[47] !== tempState.checkoutPage.description) {
    t25 = <StoreTextEditor label={t19} required={true} content={t20} onChange={t21} className={t23} error={t24} extensions={advancedTextEditorExtensions} />;
    $[43] = t19;
    $[44] = t21;
    $[45] = t23;
    $[46] = t24;
    $[47] = tempState.checkoutPage.description;
    $[48] = t25;
  } else {
    t25 = $[48];
  }
  let t26;
  if ($[49] !== t) {
    t26 = t("dashboard.simple_mail_editor.character_count.html_tooltip");
    $[49] = t;
    $[50] = t26;
  } else {
    t26 = $[50];
  }
  let t27;
  if ($[51] !== t26) {
    t27 = <Hint className="ml-auto mr-2" label={t26} />;
    $[51] = t26;
    $[52] = t27;
  } else {
    t27 = $[52];
  }
  let t28;
  if ($[53] !== t25 || $[54] !== t27) {
    t28 = <div className="flex flex-col gap-1">{t25}{t27}</div>;
    $[53] = t25;
    $[54] = t27;
    $[55] = t28;
  } else {
    t28 = $[55];
  }
  let t29;
  if ($[56] !== t18 || $[57] !== t28) {
    t29 = <div className="flex flex-col gap-5">{t18}{t28}</div>;
    $[56] = t18;
    $[57] = t28;
    $[58] = t29;
  } else {
    t29 = $[58];
  }
  let t30;
  if ($[59] !== t29 || $[60] !== t7) {
    t30 = {
      key: "text",
      title: t7,
      element: t29
    };
    $[59] = t29;
    $[60] = t7;
    $[61] = t30;
  } else {
    t30 = $[61];
  }
  let t31;
  if ($[62] !== t) {
    t31 = t("dashboard.store.item.collect_info");
    $[62] = t;
    $[63] = t31;
  } else {
    t31 = $[63];
  }
  let t32;
  if ($[64] !== setTempState) {
    t32 = fields => setTempState(prev_3 => ({
      ...prev_3,
      checkoutPage: {
        ...prev_3.checkoutPage,
        fields
      }
    }));
    $[64] = setTempState;
    $[65] = t32;
  } else {
    t32 = $[65];
  }
  const t33 = errors["checkoutPage.fields"];
  let t34;
  if ($[66] !== t32 || $[67] !== t33 || $[68] !== tempState.checkoutPage.fields) {
    t34 = <StoreFields fields={tempState.checkoutPage.fields} onChange={t32} initFields={physicalProductInitFields} error={t33} />;
    $[66] = t32;
    $[67] = t33;
    $[68] = tempState.checkoutPage.fields;
    $[69] = t34;
  } else {
    t34 = $[69];
  }
  let t35;
  if ($[70] !== t31 || $[71] !== t34) {
    t35 = {
      key: "fields",
      title: t31,
      element: t34
    };
    $[70] = t31;
    $[71] = t34;
    $[72] = t35;
  } else {
    t35 = $[72];
  }
  let t36;
  if ($[73] !== t) {
    t36 = t("dashboard.store.product.checkout.payment_methods");
    $[73] = t;
    $[74] = t36;
  } else {
    t36 = $[74];
  }
  const t37 = errors["digitalStore.paymentMethods"];
  let t38;
  if ($[75] !== t37) {
    t38 = <PaymentMethodsEditModal errors={{
      paymentMethods: t37
    }} />;
    $[75] = t37;
    $[76] = t38;
  } else {
    t38 = $[76];
  }
  let t39;
  if ($[77] !== t36 || $[78] !== t38) {
    t39 = {
      key: "payment methods",
      title: t36,
      element: t38
    };
    $[77] = t36;
    $[78] = t38;
    $[79] = t39;
  } else {
    t39 = $[79];
  }
  let t40;
  if ($[80] !== t30 || $[81] !== t35 || $[82] !== t39 || $[83] !== t6) {
    t40 = <ItemSteps steps={[t6, t30, t35, t39]} />;
    $[80] = t30;
    $[81] = t35;
    $[82] = t39;
    $[83] = t6;
    $[84] = t40;
  } else {
    t40 = $[84];
  }
  return t40;
};